import React from 'react';
import './WinModal.css';
import { useTranslation } from 'react-i18next';

// Курс обмена: 1 TON = 269 звезд
const TON_TO_STARS_RATE = 269;

const WinModal = ({ prize, onWithdraw, onSell, onClose }) => {
  const { t } = useTranslation();

  if (!prize) {
    return null;
  }

  // Расчет цены в TON
  const tonPrice = prize.price > 0 ? (prize.price / TON_TO_STARS_RATE).toFixed(2) : 0;

  // Fallback for closing when clicking the overlay
  const handleOverlayClick = () => {
    onClose();
  };

  // Prevent modal from closing when clicking inside it
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="win-modal-overlay-nova" onClick={handleOverlayClick}>
      <div className="win-modal-content-nova" onClick={handleContentClick}>
        <button className="close-button-nova" onClick={onClose}>×</button>
        <div className="win-modal-header-nova">
          <h2>{t('win_modal_title')}</h2>
          <p>{t('win_modal_subtitle')}</p>
        </div>
        <div className="won-prize-display-nova">
          <div className="win-modal-prize-image-container">
            <img src={`/prizes/${prize.image}`} alt={prize.name} className="won-prize-image-nova" />
          </div>
          <h3 className="won-prize-name-nova">{prize.name}</h3>
        </div>
        <div className="win-modal-actions-nova">
          <button className="win-modal-btn withdraw-btn" onClick={onWithdraw}>
            {t('withdraw')}
          </button>
          <button className="win-modal-btn sell-btn" onClick={onSell}>
            <div className="sell-price-container">
              <div className="sell-price-stars">
                {t('sell_for')} {prize.price} <img src="/icons/stars-symbol.png" alt="stars" className="case-star-icon-nova" style={{width: 16, height: 16}} />
              </div>
              <div className="sell-price-ton">
                <img src="/icons/ton_symbol.png" alt="TON" className="sell-ton-icon" />
                {tonPrice}
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WinModal; 